// List of colleges in Bangalore
export const bangaloreColleges = [
  'RV College of Engineering',
  'BMS College of Engineering',
  'MS Ramaiah Institute of Technology',
  'PES University',
  'Dayananda Sagar College of Engineering',
  'Dayananda Sagar Academy of Technology and Management',
  'BMS Institute of Technology',
  'Ramaiah University of Applied Sciences',
  'Christ University',
  'Mount Carmel College',
  'St. Joseph\'s College',
  'Jain University',
  'Presidency University',
  'CMR Institute of Technology',
  'New Horizon College of Engineering',
  'Acharya Institute of Technology',
  'Sir M Visvesvaraya Institute of Technology',
  'Bangalore Institute of Technology',
  'RNS Institute of Technology',
  'JSS Academy of Technical Education',
  'Nitte Meenakshi Institute of Technology',
  'Others (Type your college name)'
];
